// the host name is only needed here to avoid an error - any host will do
export const getPathnameFromUrl = (url: string) => new URL(url, 'https://www.anyhost.com').pathname;

export const addParamsToHref = (
  href: string,
  params: Record<string, string | number | boolean>,
) => {
  const [path, paramsString] = href.split('?');
  const searchParams = new URLSearchParams(paramsString);

  Object.entries(params).forEach(([param, value]) => {
    searchParams.set(param, String(value));
  });

  const searchParamsString = searchParams.toString();

  return searchParamsString.length ? `${path}?${searchParamsString}` : href;
};

export const getHashFromURL = (url: string) => {
  return url.indexOf('#') >= 0 ? url.split('#')[1] : undefined;
};
